import type { InboxThread } from "@tellescope/types-models";
import { cn, getChannelColor } from "@tellescope/ui";
import { Mail, MessageCircle, Phone, Smartphone } from "lucide-react";
import { useLocation } from "react-router-dom";
import { getZendeskSrc } from "../../../../utils";

export interface ChannelIconProps {
  channel: InboxThread["type"];
  className?: string;
  showChannelColor?: boolean; // Option to enable/disable channel coloring
}

export const ChannelIcon = ({ channel, className, showChannelColor = true }: ChannelIconProps) => {
  const location = useLocation();
  const color = getChannelColor(channel);
  const iconClassName = cn("h-3 w-3", showChannelColor ? color.iconColor : "text-muted-foreground", className);

  switch (channel) {
    case "Phone":
      return <Phone className={iconClassName} />;
    case "GroupMMS":
    case "SMS":
      return <Smartphone className={iconClassName} />;
    case "Chat":
      return <MessageCircle className={iconClassName} />;
    case "Email":
      return <Mail className={iconClassName} />;
    case "Zendesk":
      return showChannelColor ? (
        <img
          src={getZendeskSrc(location)}
          className={cn("h-2.5 w-2.5", className)}
          style={{ filter: "brightness(0.2)" }}
          alt="Zendesk"
        />
      ) : (
        <img src={getZendeskSrc(location)} className={cn("h-2.5 w-2.5 opacity-50", className)} alt="Zendesk" />
      );
    default:
      return <MessageCircle className={iconClassName} />;
  }
};
